export default new URL("../images/slide4.jpg", import.meta.url).href;